import { getUser, logout } from '../core/auth/auth';
import { Group } from '../core/auth/Response';
import { AccessFunctionality } from "./interface/AccessFunctionality";
import { getAccessFunctionality } from './Authorization.service';

const filter = (list: Group[]): String[] => {
    let lista: String[] = list.flatMap((el: Group) => { return el.cn ? el.cn : [] });
    return lista;
}

export const Authorization = async (group: Group[]): Promise<String[]> => {
    let list: AccessFunctionality[] = [];
    const groupAux = { 'grupos': filter(group) }
    await getAccessFunctionality(groupAux).then((res) => {
        list = res.data;
    }).catch((error) => {
        console.log('ERROR', error);
    });
    return list.flatMap((el: any) => { return el.NomeFuncionalidade ? String(el.NomeFuncionalidade).toLowerCase() : [] });
};

export const AuthorizationOption = (option: string): boolean => {
    if (!getUser().access) {
        logout();
        return false;
    }
    return getUser().access.length ? getUser().access.includes(option.toLowerCase()) : false;
};